import React from 'react';

export type LegacyProject = {
  title: string;
  description: string;
  icon: 'globe' | 'mobile' | 'terminal' | 'wifi';
  tech: string[];
  github_link?: string;
  text_link?: string;
};

type LegacyProjectCardProps = {
  project: LegacyProject;
};

const projectMarks: Record<LegacyProject['icon'], string> = {
  globe: '◎',
  mobile: '▯',
  terminal: '>_',
  wifi: '◔',
};

const LegacyProjectCard: React.FC<LegacyProjectCardProps> = ({ project }) => (
  <article className="legacy-project-card">
    <div className="legacy-card-icons">
      <span className="legacy-project-mark" aria-hidden="true">
        {projectMarks[project.icon]}
      </span>
      <span className="legacy-card-links">
        {project.github_link && (
          <a
            href={project.github_link}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${project.title} on GitHub`}
            title="GitHub"
          >
            GH
          </a>
        )}
        {project.text_link && (
          <a
            href={project.text_link}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${project.title} document`}
            title="Project document"
          >
            ▤
          </a>
        )}
      </span>
    </div>
    <h3>{project.title}</h3>
    <p>{project.description}</p>
    <span className="legacy-tech">{project.tech.join(', ')}</span>
  </article>
);

export default LegacyProjectCard;
